import type { ReactNode } from 'react';
import { useRailSlot } from '@/components/RailOutlet';

/**
 * Declarative form of `useRailSlot`: render this anywhere in a page to show `content` in the app's
 * right rail while `visible` is true. Renders nothing itself.
 */
export function RailOutletSlot({ visible, content, onClose, label }: { visible: boolean; content: ReactNode; onClose?: () => void; label?: string }) {
  useRailSlot(visible ? content : null, onClose, label);
  return null;
}
